import { _ as __read } from '../../tslib.es6-14c74580.js';
import { useState, useCallback, useEffect } from 'react';

var useOutsideClick = function (ref) {
    var _a = __read(useState(false), 2), toggle = _a[0], setToggle = _a[1];
    var handleToggle = useCallback(function () {
        setToggle(function (prev) { return !prev; });
    }, []);
    var handleClick = useCallback(function (e) {
        if (ref && ref.current && !ref.current.contains(e.target)) {
            setToggle(false);
        }
    }, [ref]);
    useEffect(function () {
        if (toggle === true) {
            document.addEventListener('click', handleClick);
            return function () {
                document.removeEventListener('click', handleClick);
            };
        }
    }, [handleClick, toggle]);
    return [toggle, handleToggle];
};

export { useOutsideClick };
